// Tailwind purges classes it can't statically detect. The class-lookup maps
// below let dynamic colour/accent props resolve to literal class strings the
// JIT can extract — e.g. `text-${accent}-700` would silently produce no CSS,
// so we route through these explicit dictionaries instead.

export const TOTAL_ACCENT_CLASS = {
  emerald: "text-emerald-700",
  red: "text-red-700",
  purple: "text-purple-700",
};

export const PLATFORM_COLOR_CLASS = {
  purple: { tile: "bg-purple-100 text-purple-700", pill: "text-purple-700 bg-purple-50" },
  green:  { tile: "bg-green-100 text-green-700",   pill: "text-green-700 bg-green-50" },
};

// Single status badge for every GroupedTrip state — used by both the Issues
// panel and the Recent Trips table. Class strings stay literal for Tailwind.
export const STATUS_BADGE = {
  complete:        { label: "Complete",        classes: "bg-green-100 text-green-700 border-green-200" },
  cancelled_late:  { label: "Late",            classes: "bg-gray-100 text-gray-700 border-gray-200" },
  cancelled_early: { label: "Cancelled Early", classes: "bg-red-50 text-red-700 border-red-200" },
  on_route:        { label: "On Route",        classes: "bg-blue-50 text-blue-700 border-blue-200" },
  accepted:        { label: "Accepted",        classes: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  scheduled:       { label: "Scheduled",       classes: "bg-purple-50 text-purple-700 border-purple-200" },
  pending:         { label: "Pending",         classes: "bg-yellow-50 text-yellow-700 border-yellow-200" },
};

export const PAGE_SIZE = 10;

export const CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
